import { ref, computed, unref } from 'vue';
import { customerAccountService } from '@/services/customerAccountService';

export function useCustomerAccount(leadIdRef) {
  const sites = ref([]);
  const contacts = ref([]);
  const loading = ref(false);
  const loaded = ref(false);

  const activeSites = computed(() => sites.value.filter((site) => !site.archived_at));
  const activeContacts = computed(() => contacts.value.filter((contact) => !contact.archived_at));

  const fetchAccount = async ({ includeArchived = false } = {}) => {
    const leadId = unref(leadIdRef);
    if (!leadId) return;
    loading.value = true;
    try {
      const [siteRows, contactRows] = await Promise.all([
        customerAccountService.getSites(leadId, { includeArchived }),
        customerAccountService.getContacts(leadId, { includeArchived }),
      ]);
      sites.value = siteRows;
      contacts.value = contactRows;
      loaded.value = true;
    } finally {
      loading.value = false;
    }
  };

  return { sites, contacts, activeSites, activeContacts, loading, loaded, fetchAccount };
}
